module.exports = __webpack_public_path__ + "static/media/10.17452cec.ogg";